import axios from "axios";
import store from "../redux/store";
import { loginSuccess, logout } from "../redux/authSlice";

const API_URI = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: API_URI,
  withCredentials: true,
  timeout: 90000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = store.getState().auth.accessToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const res = await axios.post(`${API_URI}/refresh-token`, {}, { withCredentials: true });
        const newAccessToken = res.data.accessToken;

        if (newAccessToken) {
          const { user, googleToken } = store.getState().auth;
          const newExpiry = Date.now() + 60 * 60 * 1000;

          store.dispatch(
            loginSuccess({
              user,
              accessToken: newAccessToken,
              googleToken,
              tokenExpiryTime: newExpiry,
            })
          );
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return axiosInstance(originalRequest);
        }
      } catch (err) {
        console.error("Refresh token failed", err.response?.data || err.message);
        store.dispatch(logout());
        return Promise.reject(err);
      }
    }

    // Case 2: Forbidden → logout (session invalidated, revoked, etc.);
    if (error.response?.status === 403) {
      const msg = error.response?.data?.message || "❌ You are not authorized to perform this action.";
      console.warn(msg);
      //alert(msg);

      return Promise.reject(error);
    }

    // Case 3: Network/other errors → don’t logout, just reject
    return Promise.reject(error);
  }
);

export default axiosInstance;
